import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=ccb4df3e&"
import script from "./PageBase.vue?vue&type=script&lang=js&"
export * from "./PageBase.vue?vue&type=script&lang=js&"
import style0 from "./PageBase.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports